const RegionSelection = {
	init: function(){
		const self = this;
		const postal_code_btn_class = '.location-method';

		postal_code_btn = document.querySelectorAll(postal_code_btn_class);
		for ( i = 0; i < postal_code_btn.length; ++i ) {
			postal_code_btn[i].addEventListener( 'click', self.postal_code_toggle, false );
		}
	},
	postal_code_toggle: function(e){
		e.preventDefault();
		e.stopPropagation();

		const form_class = '.select-region-new';
		const form_object = document.querySelector(form_class);
		let select_fields_show = 'none';
		let postal_code_fields_show = 'none';
		const select_field_ids = '#field_4_3, #field_4_1';
		const postal_code_field_ids = '#field_4_2, #field_4_6';
		const postal_code_field = document.getElementById('input_4_2');
		const lookup_method_field = document.getElementById('input_4_5');

		// On toggle add and remove the active class from the form
		if ( !form_object.classList.contains('postal-code-active') ) {
			form_object.classList.add( 'postal-code-active' );
			form_object.classList.remove( 'region-select-active' );

			// show postal code and hide dropdown
			select_fields_show = 'none';
			postal_code_fields_show = 'block';
			postal_code_field.disabled = false;
			lookup_method_field.value = 'postal-code';
		}else{
			form_object.classList.remove( 'postal-code-active' );

			// show dropdown and hide postal code
			select_fields_show = 'block';
			postal_code_fields_show = 'none';
			postal_code_field.disabled = true;
			lookup_method_field.value = 'auto';
		}

		//Loop through all fields related to the dropdown functionality
		select_fields = document.querySelectorAll( select_field_ids );
		for ( i = 0; i < select_fields.length; ++i ) {
			// select_fields_show = 'block';
			select_fields[i].style.display = select_fields_show;
		}

		//Loop through all fields related to the postal code functionality
		postal_code_fields = document.querySelectorAll( postal_code_field_ids );
		for ( i = 0; i < postal_code_fields.length; ++i ) {
			// postal_code_fields_show = 'block';
			postal_code_fields[i].style.display = postal_code_fields_show;
		}

	}
}
RegionSelection.init();